import { Link } from "react-router-dom";
import { motion } from "framer-motion";

interface LogoProps {
  size?: "nav" | "footer";
}

const Logo = ({ size = "nav" }: LogoProps) => {
  const frameClass = size === "nav"
    ? "h-10 w-[8.75rem] overflow-hidden sm:h-[3.4rem] sm:w-[12.5rem] lg:h-[3.8rem] lg:w-[15rem]"
    : "h-14 w-[14rem] overflow-hidden sm:w-[15rem]";
  const imageClass = size === "nav"
    ? "h-full w-full object-contain object-center scale-[1.92] translate-x-[1%] translate-y-[1%] sm:scale-[2.05] sm:translate-x-[2%] sm:translate-y-[7%] lg:scale-[2.18] lg:translate-x-[4%] lg:translate-y-[10%]"
    : "h-full w-full object-contain object-center scale-[2.12] translate-x-[4%] translate-y-[3%]";

  return (
    <Link to="/#home" className="group flex shrink-0 items-center" aria-label="Inbloqs home">
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className={`relative ${frameClass} flex items-center justify-center`}
      >
        <img
          src="/inbloqs_logo3.png"
          alt="Inbloqs Logo"
          className={`${imageClass} pointer-events-none transition-all duration-300`}
        />
      </motion.div>
    </Link>
  );
};

export default Logo;
